export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl overflow-hidden relative">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20abstract%20gradient%20with%20deep%20charcoal%20and%20subtle%20crimson%20accents%2C%20professional%20contact%20section%20backdrop%2C%20minimal%20geometric%20texture%2C%20warm%20dramatic%20lighting%20from%20corner%2C%20no%20text&width=1400&height=400&seq=contact-bg-hlv&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-background-950/75" />
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 px-6 py-12 md:px-12 md:py-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-white">
                联系我们
              </h2>
              <p className="text-sm md:text-base text-white/70 mt-3 max-w-lg mx-auto lg:mx-0">
                有猛料想爆料？有内幕想分享？欢迎通过以下方式联系黑料社团队，您的信息将被严格保密。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <a
                href="mailto:tips@heiliaovideo.example.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line text-lg" />
                邮件爆料
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-question-line text-lg" />
                查看常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}